import { Button, Card, CardBody, CardHeader, Spinner, Switch } from "@heroui/react"
import { ShieldCheckIcon } from "@heroicons/react/24/outline"
import PropTypes from "prop-types"

const ParentPermissions = ({ handleSave, handleUpdate, isDirty, isLoading, isSaving, settings }) => (
  <Card className="mt-3">
    <CardHeader className="justify-between text-white bg-indigo-700">
      <div className="flex items-center">
        <ShieldCheckIcon className="mr-2 w-14 h-14" />
        <div className="flex flex-col mr-8">
          <h1 className="text-lg font-semibold">Parent Permissions</h1>
          <p className="text-sm">Control parents' access.</p>
        </div>
      </div>

      <Button color="success" isDisabled={!isDirty || isLoading} isLoading={isSaving} className="font-semibold text-white" onPress={() => handleSave()}>Save</Button>
    </CardHeader>

    <CardBody>
      <div className="px-4 pb-3 border-gray-200 border-dotted border-b-1">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="font-semibold">Allow Parent Notes</h3>
            <p className="text-content2-foreground">Allow parents to share comments with the teacher.</p>
          </div>
        
          {isLoading && <Spinner className="ml-8" />}
        
          {!isLoading && (
            <Switch 
              color="success" 
              isSelected={settings.allow_parent_notes} 
              onValueChange={(value) => handleUpdate('allow_parent_notes', value)} aria-label="Allow parent notes" 
            />
          )}        
        </div>
      </div>

      <div className="px-4 py-3">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="font-semibold">Enable Waiting List</h3>
            <p className="text-content2-foreground">Allow parents to join a waiting list for classes that are fully booked.</p>
          </div>
        
          {isLoading && <Spinner className="ml-8" />}
        
          {!isLoading && (
            <Switch 
              color="success" 
              isSelected={settings.allow_parent_waiting_list} 
              onValueChange={(value) => handleUpdate('allow_parent_waiting_list', value)} aria-label="Enable waiting list" 
            />
          )}        
        </div>
      </div>
    </CardBody>
  </Card>
)

ParentPermissions.propTypes = {
  handleSave: PropTypes.func.isRequired,
  handleUpdate: PropTypes.func.isRequired,
  isDirty: PropTypes.bool,
  isLoading: PropTypes.bool,
  isSaving: PropTypes.bool,
  settings: PropTypes.shape({
    allow_parent_notes: PropTypes.bool,
    allow_parent_waiting_list: PropTypes.bool,
  }),
}

export default ParentPermissions